import { graphql } from '../../../gql';

// TRIL-275: dedicated query for the version-history page. Keeps the heavy,
// per-version S3-hydrated `blocks` OUT of the shared GET_POST_BY_ID_QUERY
// (which every post-detail view runs) — only the history page fetches them.
export const GET_POST_VERSIONS_QUERY = graphql(`
  query getPostVersions($postId: String!) {
    getPostById(postId: $postId) {
      id
      authorId
      postAnalytics {
        author {
          userId
          username
        }
      }
      textBlocksVersions {
        version
        contentRef
        timestamp
        id
        blocks {
          ...TextBlockFields
        }
      }
    }
  }
`);
